import { twMerge } from 'tailwind-merge';

import { Heading } from '../../../../../components/Heading/Heading';

interface IProps {
  buttonText: string;
  className?: string;
  onClick: () => void;
}

export const Tab = ({ buttonText, className, onClick }: IProps) => (
  <button
    type="button"
    className={twMerge('rounded-t-lg border-x-2 border-t-2 border-twilight p-2', className)}
    onClick={onClick}
  >
    <Heading variant="xs" as="h3">
      {buttonText}
    </Heading>
  </button>
);
